<template>
  <div class="container">
    <loading :active="loading" :is-full-page="true" loader="bars"></loading>
    <div class="row">
      <div class="col-md-8 mt-5 mx-auto">
        <router-link to="/admins" class="btn btn-sm btn-primary mb-3"
          >Back</router-link
        >
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Edit Admin</h4>
          </div>
          <div class="card-body">
            <form @submit.prevent="submit">
              <div class="form-group row">
                <div class="col-md-6">
                  <label>First Name <span class="text-danger">*</span></label>
                  <span class="text-danger d-block" v-if="errors.f_name">
                    First Name is required
                  </span>
                  <input
                    type="text"
                    class="form-control mb-3"
                    required
                    placeholder="First Name"
                    v-model="admin.f_name"
                  />
                </div>
                <div class="col-md-6">
                  <label>Last Name</label>
                  <input
                    type="text"
                    class="form-control mb-3"
                    placeholder="Last Name"
                    v-model="admin.l_name"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>Phone</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  v-model="admin.phone"
                  maxlength="11"
                  placeholder="03011234567"
                  @keypress="numberOnly($event)"
                />
              </div>
              <div class="form-group">
                <label>Email <span class="text-danger">*</span></label>
                <span class="text-danger d-block" v-if="errors.email">
                  {{ errors.email[0] }}
                </span>
                <input
                  type="email"
                  class="form-control mb-3"
                  required
                  placeholder="info@email.com"
                  v-model="admin.email"
                  pattern="[^\s@]+@[^\s@]+\.[^\spatt@]+"
                />
              </div>
              <div class="form-group">
                <label>Role <span class="text-danger">*</span></label>
                <select
                  class="select-form-control"
                  v-model="admin.role"
                  required
                >
                  <option value="">Select...</option>
                  <option v-for="role in roles" :value="role.name">
                    {{ role.name }}
                  </option>
                </select>
              </div>
              <div class="row mt-3">
                <div class="col-md-9">
                  <button type="submit" class="btn btn-lg btn-primary w-100">
                    Save
                  </button>
                </div>
                <div class="col-md-3">
                  <button
                    type="reset"
                    class="btn btn-lg btn-outline-danger w-100"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toRaw } from "vue";
import { isNumber } from "@/helpers/helpers";

export default {
  data() {
    return {
      admin: [],
      roles: [],
      errors: [],
      userId: null,
      loading: false,
    };
  },
  mounted() {
    this.userId = this.$route.params.id;
    this.fetch(this.userId);
    this.fetchRoles();
  },
  methods: {
    numberOnly(evt) {
      isNumber(evt);
    },
    fetch(id) {
      this.loading = false;
      this.$store
        .dispatch("admins/getSingle", { id })
        .then((response) => {
          this.admin = response.data;
          if (this.admin.roles.length > 0) {
            this.admin.role = this.admin.roles[0].name;
            this.admin.prevRole = this.admin.roles[0].name;
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
        });
    },
    submit() {
      this.loading = true;
      this.errors = [];
      const data = toRaw(this.admin);
      const id = this.userId;
      this.$store
        .dispatch("admins/update", { data, id })
        .then(() => {
          this.loading = false;
          this.$toast.show("Successfuly updated.", {
            theme: "outline",
            position: "top",
            type: "success",
            duration: 5000,
          });
          this.errors = [];
        })
        .catch((e) => {
          this.errors = e.error;
          this.loading = false;
        });
    },
    fetchRoles() {
      this.loading = true;
      const search = "";
      this.$store
        .dispatch("roles/getAll", { search })
        .then((response) => {
          this.loading = false;
          this.roles = response.data.data;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e.error);
        });
    },
  },
};
</script>
